// const isEdge = window.navigator.userAgent.indexOf('Edge') !== -1 ? true : !true
// const isIE = window.navigator.userAgent.toLowerCase().indexOf('msie') !== -1 ? true : !true
const isiPhoneSafari = window.navigator.userAgent.toLowerCase().indexOf('safari') !== -1 && window.navigator.userAgent.toLowerCase().indexOf('iphone') !== -1 ? true : !true

if (isiPhoneSafari) {
  const storeLink = document.createElement('script')
  storeLink.src = `/static/store.everything.min.js`
  document.getElementsByTagName('head')[0].appendChild(storeLink)
}



// WEBPACK FOOTER //
// ./src/lib/script.js